
import { AlertTriangle } from "lucide-react";

export const DeactivationWarning = () => {
  return (
    <div className="flex items-start gap-4 rounded-md border-2 border-yellow-500 p-4">
      <AlertTriangle className="h-5 w-5 text-yellow-500 mt-0.5" />
      <div>
        <h4 className="font-medium mb-1">Account Deactivated</h4>
        <p className="text-sm text-muted-foreground">
          Your account is currently deactivated and the 7-day grace period for self-reactivation has expired. 
          To reactivate your account, please contact us at{' '}
          <a href="mailto:hello@superalts.ca" className="text-primary hover:underline">
            hello@superalts.ca
          </a>
        </p>
      </div>
    </div>
  );
};
